import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const routes: { [key: string]: string } = {
  '/': 'Ana Sayfa',
  '/ihtiyac-kredisi': 'İhtiyaç Kredisi',
  '/kredi-kartlari': 'Kredi Kartları',
  '/konut-kredisi': 'Konut Kredisi',
  '/tasit-kredisi': 'Taşıt Kredisi'
};

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);
  
  // Don't show breadcrumb on homepage
  if (location.pathname === '/') return null;

  return (
    <div className="bg-slate-900">
      <div className="container mx-auto px-4">
        <div className="py-3">
          <nav className="flex items-center gap-2 text-sm">
            <Link 
              to="/" 
              className="text-white hover:text-[#F7BA45] transition-colors flex items-center gap-1"
            >
              <Home size={16} />
              <span>Ana Sayfa</span>
            </Link>

            {pathnames.map((name, index) => {
              const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
              const isLast = index === pathnames.length - 1;

              return (
                <React.Fragment key={name}>
                  <ChevronRight size={16} className="text-slate-500" />
                  {isLast ? (
                    <span className="text-[#F7BA45] font-medium">
                      {routes[routeTo]}
                    </span>
                  ) : (
                    <Link 
                      to={routeTo}
                      className="text-white hover:text-[#F7BA45] transition-colors"
                    >
                      {routes[routeTo]}
                    </Link>
                  )}
                </React.Fragment>
              );
            })}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;